(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4201],{

/***/ 60612:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Fq": function() { return /* binding */ CHECK_3DS_CODE; },
/* harmony export */   "GQ": function() { return /* binding */ isHavingPlusBenefits; },
/* harmony export */   "If": function() { return /* binding */ isSubbedPrimePlusBefore; },
/* harmony export */   "Vj": function() { return /* binding */ ableToShowSubscribingStatusModal; },
/* harmony export */   "W$": function() { return /* binding */ isPayingPlus; },
/* harmony export */   "WJ": function() { return /* binding */ isRenewPrimeSubStatus; },
/* harmony export */   "_I": function() { return /* binding */ isPayingPrimeSub; },
/* harmony export */   "bG": function() { return /* binding */ isHavingPrimeBenefits; },
/* harmony export */   "bm": function() { return /* binding */ showingPrimeSubPrice; },
/* harmony export */   "r$": function() { return /* binding */ isSubbingPrimeByCoin; },
/* harmony export */   "uj": function() { return /* binding */ getPrimePlusPackageStatus; },
/* harmony export */   "zB": function() { return /* binding */ plusPackageStatusText; }
/* harmony export */ });
/* unused harmony export isAbleToCreatorNewPrimeSub */
/* harmony import */ var common_interfaces_api__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(21694);
/* harmony import */ var service_payment__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(43827);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(22467);



var CHECK_3DS_CODE = "3DS-authentication-complete";
// having plus benefits
var isHavingPlusBenefits = function(creator) {
    var ref;
    if (!creator) return false;
    var primePlusPackStatus = creator === null || creator === void 0 ? void 0 : (ref = creator.option_creator_subscriptions) === null || ref === void 0 ? void 0 : ref.find(function(option) {
        return option.optional_type === service_payment__WEBPACK_IMPORTED_MODULE_1__/* .OptionalPackageName.Plus */ .vq.Plus;
    });
    if (!primePlusPackStatus) return false;
    if ((primePlusPackStatus === null || primePlusPackStatus === void 0 ? void 0 : primePlusPackStatus.status) === "active" || (primePlusPackStatus === null || primePlusPackStatus === void 0 ? void 0 : primePlusPackStatus.status) === "trialing" || (primePlusPackStatus === null || primePlusPackStatus === void 0 ? void 0 : primePlusPackStatus.status) === "canceled") return true;
    if (primePlusPackStatus.ended_at) return primePlusPackStatus.ended_at && new Date(primePlusPackStatus.ended_at) > new Date();
};
var getPrimePlusPackageStatus = function(creator) {
    var ref;
    if (!creator) return null;
    return creator === null || creator === void 0 ? void 0 : (ref = creator.option_creator_subscriptions) === null || ref === void 0 ? void 0 : ref.find(function(option) {
        return option.optional_type === service_payment__WEBPACK_IMPORTED_MODULE_1__/* .OptionalPackageName.Plus */ .vq.Plus;
    });
};
// paying for plus benefits
var isPayingPlus = function(creator) {
    var ref;
    if (!creator) return false;
    var primePlusPackStatus = creator === null || creator === void 0 ? void 0 : (ref = creator.option_creator_subscriptions) === null || ref === void 0 ? void 0 : ref.find(function(option) {
        return option.optional_type === service_payment__WEBPACK_IMPORTED_MODULE_1__/* .OptionalPackageName.Plus */ .vq.Plus;
    });
    if (!primePlusPackStatus) return false;
    return (primePlusPackStatus === null || primePlusPackStatus === void 0 ? void 0 : primePlusPackStatus.status) === "active" || (primePlusPackStatus === null || primePlusPackStatus === void 0 ? void 0 : primePlusPackStatus.status) === "trialing" || (primePlusPackStatus === null || primePlusPackStatus === void 0 ? void 0 : primePlusPackStatus.status) === "unpaid";
};
var isSubbingPrimeByCoin = function(creator) {
    var ref;
    if (!creator) return false;
    return [
        "web_coin",
        "android_coin",
        "ios_coin"
    ].includes(creator === null || creator === void 0 ? void 0 : (ref = creator.creator_subscription) === null || ref === void 0 ? void 0 : ref.platform);
};
var isSubbedPrimePlusBefore = function(creator) {
    var ref;
    if (!creator) return false;
    var primePlusPackStatus = creator === null || creator === void 0 ? void 0 : (ref = creator.option_creator_subscriptions) === null || ref === void 0 ? void 0 : ref.find(function(option) {
        return option.optional_type === service_payment__WEBPACK_IMPORTED_MODULE_1__/* .OptionalPackageName.Plus */ .vq.Plus;
    });
    if (!primePlusPackStatus) return false;
    return !!(primePlusPackStatus === null || primePlusPackStatus === void 0 ? void 0 : primePlusPackStatus.is_subscribed_before);
};
var ableToShowSubscribingStatusModal = function(creator) {
    if (!creator) return false;
    return isHavingPlusBenefits(creator) || isRenewPrimeSubStatus(creator) || isPayingPrimeSub(creator);
};
var plusPackageStatusText = function(primePlusPackStatus) {
    if (!primePlusPackStatus) return "";
    switch(primePlusPackStatus === null || primePlusPackStatus === void 0 ? void 0 : primePlusPackStatus.status){
        case "active":
            return "登録中";
        case "trialing":
            return "無料体験中";
        case "canceled":
            return "残り".concat((0,___WEBPACK_IMPORTED_MODULE_2__/* .timeUntil */ .LW)(new Date(primePlusPackStatus.ended_at), common_interfaces_api__WEBPACK_IMPORTED_MODULE_0__/* .Language.Ja */ .SQ.Ja));
        default:
            return "";
    }
};
var isRenewPrimeSubStatus = function(creator) {
    var ref;
    if (!creator) return false;
    return (creator === null || creator === void 0 ? void 0 : (ref = creator.creator_subscription) === null || ref === void 0 ? void 0 : ref.status) === "canceled";
};
var isPayingPrimeSub = function(creator) {
    var ref, ref1, ref2;
    if (!creator) return false;
    return (creator === null || creator === void 0 ? void 0 : (ref = creator.creator_subscription) === null || ref === void 0 ? void 0 : ref.status) === "active" || (creator === null || creator === void 0 ? void 0 : (ref1 = creator.creator_subscription) === null || ref1 === void 0 ? void 0 : ref1.status) === "trialing" || (creator === null || creator === void 0 ? void 0 : (ref2 = creator.creator_subscription) === null || ref2 === void 0 ? void 0 : ref2.status) === "unpaid";
};
var isAbleToCreatorNewPrimeSub = function(creator) {
    var ref;
    return !(creator === null || creator === void 0 ? void 0 : (ref = creator.creator_subscription) === null || ref === void 0 ? void 0 : ref.status) || isRenewPrimeSubStatus(creator);
};
var isHavingPrimeBenefits = function(creator) {
    var ref, ref1, ref2;
    if (!creator) return false;
    return (creator === null || creator === void 0 ? void 0 : (ref = creator.creator_subscription) === null || ref === void 0 ? void 0 : ref.status) === "active" || (creator === null || creator === void 0 ? void 0 : (ref1 = creator.creator_subscription) === null || ref1 === void 0 ? void 0 : ref1.status) === "trialing" || (creator === null || creator === void 0 ? void 0 : (ref2 = creator.creator_subscription) === null || ref2 === void 0 ? void 0 : ref2.status) === "canceled";
};
var showingPrimeSubPrice = function(pack, discountByMembershipWebAmount, currentPaymentBy) {
    if (discountByMembershipWebAmount > 0 && (pack === null || pack === void 0 ? void 0 : pack.recurring) === service_payment__WEBPACK_IMPORTED_MODULE_1__/* .WebPricePackageRecurring.Month */ .a5.Month && currentPaymentBy === "coin") {
        return discountByMembershipWebAmount;
    }
    if ((pack === null || pack === void 0 ? void 0 : pack.recurring) === service_payment__WEBPACK_IMPORTED_MODULE_1__/* .WebPricePackageRecurring.Month */ .a5.Month && currentPaymentBy === "coin") {
        return pack === null || pack === void 0 ? void 0 : pack.original_web_amount;
    }
    return pack === null || pack === void 0 ? void 0 : pack.discounted_web_amount;
};


/***/ }),

/***/ 84499:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Profile; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/axios/lib/axios.js + 48 modules
var axios = __webpack_require__(87066);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/react-query/es/index.js
var es = __webpack_require__(88767);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./store/timeline.ts
var timeline = __webpack_require__(12800);
// EXTERNAL MODULE: ./store/global.ts
var global = __webpack_require__(8405);
// EXTERNAL MODULE: ./components/common/RoundIcon/index.tsx
var RoundIcon = __webpack_require__(10184);
// EXTERNAL MODULE: ./components/common/Icon/index.tsx
var Icon = __webpack_require__(37975);
// EXTERNAL MODULE: ./components/common/FileSelect/index.tsx
var FileSelect = __webpack_require__(69090);
// EXTERNAL MODULE: ./components/common/ImageEditor/index.tsx
var ImageEditor = __webpack_require__(20849);
// EXTERNAL MODULE: ./components/common/PopperWrapper/index.tsx
var PopperWrapper = __webpack_require__(74688);
// EXTERNAL MODULE: ./components/common/EmotionSelector/index.tsx
var EmotionSelector = __webpack_require__(10086);
// EXTERNAL MODULE: ./common/utils/index.ts + 1 modules
var utils = __webpack_require__(22467);
// EXTERNAL MODULE: ./components/Profile/Profile.module.scss
var Profile_module = __webpack_require__(45841);
var Profile_module_default = /*#__PURE__*/__webpack_require__.n(Profile_module);
// EXTERNAL MODULE: ./components/Profile/BioSection/BioSection.module.scss
var BioSection_module = __webpack_require__(70557);
var BioSection_module_default = /*#__PURE__*/__webpack_require__.n(BioSection_module);
;// CONCATENATED MODULE: ./components/Profile/BioSection/index.tsx





var BioSection = function(param) {
    var user = param.user;
    var ref = (0,react.useState)(true), isShortMode = ref[0], setShortMode = ref[1];
    var ref1 = (0,react.useState)(true), hasShortMode = ref1[0], setHasShortMode = ref1[1];
    var bioRef = (0,react.useCallback)(function(node) {
        setShortMode(true);
        var initShortMode = setTimeout(function() {
            if (node !== null) {
                var scrollHeight = node.scrollHeight;
                var clientHeight = node.clientHeight;
                setHasShortMode(scrollHeight > clientHeight);
            }
        }, 500);
        return function() {
            return clearTimeout(initShortMode);
        };
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        user === null || user === void 0 ? void 0 : user.bio,
        user === null || user === void 0 ? void 0 : user.username
    ]);
    if (!(user === null || user === void 0 ? void 0 : user.bio)) return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (BioSection_module_default()).bioSection,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: classnames_default()((BioSection_module_default()).bio, (0,_define_property/* default */.Z)({}, (BioSection_module_default()).notShortMode, !isShortMode)),
                ref: bioRef,
                children: user.bio
            }),
            hasShortMode && (isShortMode ? /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                onClick: function() {
                    return setShortMode(false);
                },
                className: (BioSection_module_default()).readmore,
                children: "続きを読む"
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                onClick: function() {
                    setShortMode(true);
                    window.scrollTo(0, 0);
                },
                className: (BioSection_module_default()).readmore,
                children: "一部を表示"
            }))
        ]
    });
};
/* harmony default export */ var Profile_BioSection = (BioSection);

// EXTERNAL MODULE: ./components/common/BadgeIcon/index.tsx
var BadgeIcon = __webpack_require__(85650);
// EXTERNAL MODULE: ./components/common/Button/index.tsx
var Button = __webpack_require__(98133);
// EXTERNAL MODULE: ./components/common/ProgressIcon/index.tsx
var ProgressIcon = __webpack_require__(39186);
;// CONCATENATED MODULE: ./components/Profile/RatingInfoSection/index.tsx












var RatingInfoSection = function(param) {
    var user = param.user, isMobileScreen = param.isMobileScreen, browserWidth = param.browserWidth;
    var currentUser = (0,timeline/* default */.ZP)(function(state) {
        return state.currentUser;
    });
    var refetchProfile = (0,timeline/* default */.ZP)(function(state) {
        return state.refetchProfile;
    });
    var showProfileHelpDialog = (0,global/* default */.Z)(function(state) {
        return state.showProfileHelpDialog;
    });
    var updateUserSettings = (0,react.useCallback)((0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return axios/* default.patch */.Z.patch("/users/settings", {
                        rating_system: true
                    });
                case 3:
                    refetchProfile();
                    _ctx.next = 10;
                    break;
                case 6:
                    _ctx.prev = 6;
                    _ctx.t0 = _ctx["catch"](0);
                    console.error("Error updating user settings!");
                    console.error(_ctx.t0);
                case 10:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                6
            ]
        ]);
    })), [
        refetchProfile
    ]);
    if (!user) return;
    var isCurrentUser = (user === null || user === void 0 ? void 0 : user.username) === (currentUser === null || currentUser === void 0 ? void 0 : currentUser.username);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            user.rating_system_is_on ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (Profile_module_default()).statsGroup,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (Profile_module_default()).stats,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (Profile_module_default()).statsTop,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (Profile_module_default()).statsLeft,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProgressIcon/* default */.Z, {
                                            icon: "hearts-stat-2",
                                            current: user.interaction_rate,
                                            total: 100,
                                            secondColor: "#FAC8D2",
                                            strokeColor: "#FF6074",
                                            zoom: 1.2
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (Profile_module_default()).statsRight,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (Profile_module_default()).statsNum,
                                            children: [
                                                user.interaction_rate,
                                                "%"
                                            ]
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (Profile_module_default()).statsBottom,
                                children: "インタレスト"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (Profile_module_default()).stats,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (Profile_module_default()).statsTop,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (Profile_module_default()).statsLeft,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProgressIcon/* default */.Z, {
                                            icon: "share-on",
                                            current: user.engagement_rate,
                                            total: 100,
                                            secondColor: "#BEE2FA",
                                            strokeColor: "#70C3F2",
                                            zoom: 1.2
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (Profile_module_default()).statsRight,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (Profile_module_default()).statsNum,
                                            children: [
                                                user.engagement_rate,
                                                "%"
                                            ]
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (Profile_module_default()).statsBottom,
                                children: "エンゲージ"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (Profile_module_default()).stats,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (Profile_module_default()).statsTop,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (Profile_module_default()).statsLeft,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProgressIcon/* default */.Z, {
                                            icon: "followers-stat-2",
                                            current: 100,
                                            total: 100,
                                            strokeColor: "#6575DD",
                                            secondColor: "#818CEE",
                                            zoom: 1.2
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (Profile_module_default()).statsRight,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (Profile_module_default()).statsNum,
                                            children: user.follow_count
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (Profile_module_default()).statsBottom,
                                children: "フォロワー"
                            })
                        ]
                    })
                ]
            }) : currentUser && isCurrentUser ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: classnames_default()((Profile_module_default()).statsGroup, (Profile_module_default()).statsGroupCtrl),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                    text: "バッジレベルをONにする",
                    blackAndWhite: true,
                    fadingStyle: true,
                    fullWidth: true,
                    bigGuyStyle: true,
                    onClick: function() {
                        return updateUserSettings();
                    }
                })
            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (Profile_module_default()).meterDisableLabel,
                children: [
                    "バッジレベルの設定が",
                    isMobileScreen && /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    "OFFになっています"
                ]
            }),
            user.rating_system_is_on && user.badge && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (Profile_module_default()).badgeGroup,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (Profile_module_default()).badge,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BadgeIcon/* default */.Z, {
                            badge: !user.is_advertiser ? user.badge : "advertiser",
                            width: isMobileScreen ? browserWidth / 4 : 86,
                            height: isMobileScreen ? browserWidth / 4 : 86
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (Profile_module_default()).help,
                        onClick: function() {
                            return showProfileHelpDialog(true);
                        },
                        children: [
                            "?",
                            !isMobileScreen && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: (Profile_module_default()).tooltip,
                                children: "バッジシステムについて"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var Profile_RatingInfoSection = (RatingInfoSection);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./common/interfaces/api.ts
var api = __webpack_require__(21694);
// EXTERNAL MODULE: ./components/common/BigButton/index.tsx
var BigButton = __webpack_require__(77041);
// EXTERNAL MODULE: ./components/Profile/FollowButtonsGroup/FollowButtonsGroup.module.scss
var FollowButtonsGroup_module = __webpack_require__(82597);
var FollowButtonsGroup_module_default = /*#__PURE__*/__webpack_require__.n(FollowButtonsGroup_module);
// EXTERNAL MODULE: ./components/common/ConfirmDialog/index.tsx
var ConfirmDialog = __webpack_require__(78257);
// EXTERNAL MODULE: ./components/common/ReportBox/index.tsx
var ReportBox = __webpack_require__(46069);
// EXTERNAL MODULE: ./components/Profile/ThreeDotsMenu/ThreeDotsMenu.module.scss
var ThreeDotsMenu_module = __webpack_require__(52692);
var ThreeDotsMenu_module_default = /*#__PURE__*/__webpack_require__.n(ThreeDotsMenu_module);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Dialog/Dialog.js + 2 modules
var Dialog = __webpack_require__(93579);
// EXTERNAL MODULE: ./components/common/LinkButton/index.tsx
var LinkButton = __webpack_require__(22396);
// EXTERNAL MODULE: ./components/Profile/SubscribingStatusModal/SubscribingStatusModal.module.scss
var SubscribingStatusModal_module = __webpack_require__(63448);
var SubscribingStatusModal_module_default = /*#__PURE__*/__webpack_require__.n(SubscribingStatusModal_module);
// EXTERNAL MODULE: ./common/utils/user.ts
var utils_user = __webpack_require__(97542);
// EXTERNAL MODULE: ./service/payment.ts
var payment = __webpack_require__(43827);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./common/utils/payment.ts
var utils_payment = __webpack_require__(60612);
;// CONCATENATED MODULE: ./components/Profile/SubscribingStatusModal/index.tsx
















function SubscribingStatusModal(param) {
    var open = param.open, setOpen = param.setOpen, creator = param.creator;
    var ref;
    var showPaymentDialog = (0,global/* default */.Z)(function(state) {
        return state.showPaymentDialog;
    });
    var handlePaymentClick = function() {
        showPaymentDialog({
            creator: creator
        });
        setOpen(false);
    };
    if (!(0,utils_payment/* ableToShowSubscribingStatusModal */.Vj)(creator)) return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    var primePlusPackStatus = (0,utils_payment/* getPrimePlusPackageStatus */.uj)(creator);
    var resubscriptionButtonText = ((ref = creator.creator_subscription) === null || ref === void 0 ? void 0 : ref.status) === "canceled" ? "プライム登録を再開する" : (primePlusPackStatus === null || primePlusPackStatus === void 0 ? void 0 : primePlusPackStatus.status) === "canceled" ? "プライムPlusの登録を再開する" : "";
    var canUpGradePlan = (0,utils_user/* isAbleToUpgradePlan */.Dn)(creator);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Dialog/* default */.Z, {
        open: open,
        onClose: function() {
            return setOpen(false);
        },
        maxWidth: "lg",
        PaperProps: {
            style: {
                backgroundColor: "transparent",
                boxShadow: "none"
            }
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (SubscribingStatusModal_module_default()).dialogWrapper,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (SubscribingStatusModal_module_default()).closeBtn,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.ZP, {
                        name: "close",
                        width: 28,
                        height: 28,
                        onClick: function() {
                            return setOpen(false);
                        }
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (SubscribingStatusModal_module_default()).descriptionSection,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (SubscribingStatusModal_module_default()).avatar,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RoundIcon/* default */.Z, {
                                user: creator,
                                width: 62,
                                height: 62,
                                hasRing: true
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (SubscribingStatusModal_module_default()).header,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                children: [
                                    creator.name,
                                    "さんの",
                                    "\n",
                                    "プライム登録・プライムPlusの登録状況"
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(PrimeSubStatus, {
                            creator: creator
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(PrimePlusStatus, {
                            creator: creator
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (SubscribingStatusModal_module_default()).actionsGroup,
                            children: [
                                creator.is_open_for_subscription && (resubscriptionButtonText ? /*#__PURE__*/ (0,jsx_runtime.jsx)(BigButton/* default */.Z, {
                                    text: resubscriptionButtonText,
                                    fadeColorWhenOn: true,
                                    onClick: handlePaymentClick,
                                    fullWidth: true
                                }) : canUpGradePlan && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                    text: "割引プランを変更",
                                    onClick: function() {
                                        showPaymentDialog({
                                            creator: creator,
                                            initPackageRecurring: payment/* WebPricePackageRecurring.Year */.a5.Year
                                        });
                                        setOpen(false);
                                    }
                                })),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CancelButtons, {
                                    creator: creator,
                                    setOpen: setOpen
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
var PrimeSubStatus = function(param) {
    var creator = param.creator;
    var ref, ref1, ref2, ref3, ref4;
    if (!((ref = creator.creator_subscription) === null || ref === void 0 ? void 0 : ref.status)) return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    if (((ref1 = creator.creator_subscription) === null || ref1 === void 0 ? void 0 : ref1.status) === "canceled") {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (SubscribingStatusModal_module_default()).subHeader,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                    className: (SubscribingStatusModal_module_default()).highlight,
                    children: [
                        "プライム登録残り",
                        (0,utils/* timeUntil */.LW)(new Date(creator.subscription_ended_at), api/* Language.Ja */.SQ.Ja)
                    ]
                }),
                "\n",
                creator.name,
                "さんの",
                "\n",
                "プライム投稿を無制限で閲覧できます。",
                "\n"
            ]
        });
    }
    if (((ref2 = creator.creator_subscription) === null || ref2 === void 0 ? void 0 : ref2.status) === "trialing" || ((ref3 = creator.creator_subscription) === null || ref3 === void 0 ? void 0 : ref3.status) === "active") {
        var ref5, ref6;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (SubscribingStatusModal_module_default()).subHeader,
            children: [
                "".concat((0,payment/* pricePackagePeriod */.pI)((ref5 = creator.creator_subscription) === null || ref5 === void 0 ? void 0 : ref5.current_plan), "プラン"),
                ((ref6 = creator.creator_subscription) === null || ref6 === void 0 ? void 0 : ref6.status) === "trialing" ? "のプライム登録を無料体験中" : "をプライム登録中"
            ]
        });
    }
    if (((ref4 = creator.creator_subscription) === null || ref4 === void 0 ? void 0 : ref4.status) === "unpaid") {
        var ref7;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (SubscribingStatusModal_module_default()).subHeader,
            children: [
                "".concat((0,payment/* pricePackagePeriod */.pI)((ref7 = creator.creator_subscription) === null || ref7 === void 0 ? void 0 : ref7.current_plan), "プランのプライム登録が"),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: (SubscribingStatusModal_module_default()).highlight1,
                    children: "決済待ち"
                })
            ]
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
};
var PrimePlusStatus = function(param) {
    var creator = param.creator;
    var primePlusPackStatus = (0,utils_payment/* getPrimePlusPackageStatus */.uj)(creator);
    if (!primePlusPackStatus) return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    switch(primePlusPackStatus === null || primePlusPackStatus === void 0 ? void 0 : primePlusPackStatus.status){
        case "active":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (SubscribingStatusModal_module_default()).subHeader,
                children: "プライムPlusを登録中"
            });
        case "trialing":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (SubscribingStatusModal_module_default()).subHeader,
                children: "プライムPlusを無料体験中"
            });
        case "canceled":
            if (primePlusPackStatus.ended_at) {
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (SubscribingStatusModal_module_default()).subHeader,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                            className: (SubscribingStatusModal_module_default()).highlight,
                            children: [
                                "プライムPlus残り",
                                (0,utils/* timeUntil */.LW)(new Date(primePlusPackStatus.ended_at), api/* Language.Ja */.SQ.Ja)
                            ]
                        }),
                        "\n",
                        creator.name,
                        "さんの",
                        "\n",
                        "プライムPlus投稿を無制限で閲覧できます。"
                    ]
                });
            } else return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
        case "unpaid":
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (SubscribingStatusModal_module_default()).subHeader,
                children: [
                    "プライムPlusが",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: (SubscribingStatusModal_module_default()).highlight1,
                        children: "決済待ち"
                    })
                ]
            });
        default:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    }
};
var CancelButtons = function(param) {
    var creator = param.creator, setOpen = param.setOpen;
    var router = (0,next_router.useRouter)();
    var setSnackbarMessage = (0,global/* default */.Z)(function(state) {
        return state.setSnackbarMessage;
    });
    var isPayingPrimePackage = (0,utils_payment/* isPayingPrimeSub */._I)(creator);
    var primePlusPackageStatus = (0,utils_payment/* getPrimePlusPackageStatus */.uj)(creator);
    var isPayingPlusPackage = (0,utils_payment/* isPayingPlus */.W$)(creator);
    var currentUser = (0,timeline/* default */.ZP)(function(state) {
        return state.currentUser;
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            isPayingPrimePackage && /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkButton/* default */.Z, {
                text: "プライム登録を解除する",
                type: "normal",
                onClick: function() {
                    var ref, ref1;
                    if (((ref = creator.creator_subscription) === null || ref === void 0 ? void 0 : ref.platform) === "android_iap") {
                        setSnackbarMessage({
                            type: "error",
                            text: "Androidアプリでプライム登録を行っています。Androidアプリからプライム登録を解除してください。",
                            autoHideDuration: 10000
                        });
                        return;
                    } else if (((ref1 = creator.creator_subscription) === null || ref1 === void 0 ? void 0 : ref1.platform) === "ios_iap") {
                        setSnackbarMessage({
                            type: "error",
                            text: "iOSアプリでプライム登録を行っています。iOSアプリからプライム登録を解除してください。",
                            autoHideDuration: 10000
                        });
                        return;
                    }
                    if (isPayingPlusPackage) {
                        setSnackbarMessage({
                            type: "error",
                            text: "プライムPlusを登録中のため、プライム登録を解除できません。",
                            autoHideDuration: 10000
                        });
                        return;
                    }
                    setOpen(false);
                    void router.push("/account/prime_subscription/".concat(creator.username, "/cancellation?pid=").concat(currentUser === null || currentUser === void 0 ? void 0 : currentUser.id));
                }
            }),
            isPayingPlusPackage && /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkButton/* default */.Z, {
                text: "プライムPlusを解除する",
                type: "normal",
                onClick: function() {
                    if ((primePlusPackageStatus === null || primePlusPackageStatus === void 0 ? void 0 : primePlusPackageStatus.platform) === "android_iap") {
                        setSnackbarMessage({
                            type: "error",
                            text: "Androidアプリでプライム登録を行っています。Androidアプリからプライム登録を解除してください。",
                            autoHideDuration: 10000
                        });
                        return;
                    } else if ((primePlusPackageStatus === null || primePlusPackageStatus === void 0 ? void 0 : primePlusPackageStatus.platform) === "ios_iap") {
                        setSnackbarMessage({
                            type: "error",
                            text: "iOSアプリでプライム登録を行っています。iOSアプリからプライム登録を解除してください。",
                            autoHideDuration: 10000
                        });
                        return;
                    }
                    setOpen(false);
                    void router.push("/account/prime_plus_subscription/".concat(creator.username, "/cancellation?pid=").concat(currentUser === null || currentUser === void 0 ? void 0 : currentUser.id));
                }
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/Profile/ThreeDotsMenu/index.tsx














function ThreeDotsMenu(param) {
    var user = param.user;
    var setSnackbarMessage = (0,global/* default */.Z)(function(state) {
        return state.setSnackbarMessage;
    });
    var showLogin = (0,global/* default */.Z)(function(state) {
        return state.showLogin;
    });
    var currentUser = (0,timeline/* default */.ZP)(function(state) {
        return state.currentUser;
    });
    var ref = (0,react.useState)(false), show = ref[0], setShow = ref[1];
    var threeDotRef = (0,react.useRef)();
    (0,utils/* useOutsideClick */.O3)(threeDotRef, function() {
        if (show) setShow(false);
    });
    var ref1 = (0,react.useState)(false), showSubscribingStatusModal = ref1[0], setShowSubscribingStatusModal = ref1[1];
    var ref2 = (0,react.useState)(false), openConfirmBlockUser = ref2[0], setOpenConfirmBlockUser = ref2[1];
    var ref3 = (0,react.useState)(false), openConfirmReportUser = ref3[0], setOpenConfirmReportUser = ref3[1];
    var handleBlockUser = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return axios/* default.post */.Z.post("/users/blocks", {
                            user_id: user.id,
                            action: "block"
                        });
                    case 3:
                        setSnackbarMessage({
                            text: "ユーザーがブロックされました",
                            type: "success"
                        });
                        setOpenConfirmBlockUser(false);
                        _ctx.next = 10;
                        break;
                    case 7:
                        _ctx.prev = 7;
                        _ctx.t0 = _ctx["catch"](0);
                        setSnackbarMessage({
                            type: "error",
                            text: "ユーザーのブロックが失敗しました"
                        });
                    case 10:
                        setShow(false);
                    case 11:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    7
                ]
            ]);
        }));
        return function handleBlockUser() {
            return _ref.apply(this, arguments);
        };
    }();
    var content = /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
        className: (ThreeDotsMenu_module_default()).menuWrapper,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                onClick: function() {
                    return setOpenConfirmBlockUser(true);
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.ZP, {
                        name: "user-off",
                        width: 24,
                        height: 24
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: "ユーザーをブロックする"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                onClick: function() {
                    return setOpenConfirmReportUser(true);
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.ZP, {
                        name: "user-report",
                        width: 24,
                        height: 24
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: "ユーザーをレポートする"
                    })
                ]
            }),
            (0,utils_payment/* ableToShowSubscribingStatusModal */.Vj)(user) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                onClick: function() {
                    return setShowSubscribingStatusModal(true);
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.ZP, {
                        name: "priming",
                        width: 24,
                        height: 24
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: "プライム登録を管理する"
                    })
                ]
            })
        ]
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (ThreeDotsMenu_module_default()).threeDotsMenuWrapper,
        ref: threeDotRef,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (ThreeDotsMenu_module_default()).triggerWrapper,
                onClick: function() {
                    if (!currentUser) {
                        showLogin({});
                        return;
                    }
                    setShow(!show);
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.ZP, {
                    name: "dropdown-square",
                    width: 60,
                    height: 60
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (ThreeDotsMenu_module_default()).contentWrapper,
                style: {
                    display: show ? "block" : "none"
                },
                children: content
            }),
            openConfirmBlockUser && /*#__PURE__*/ (0,jsx_runtime.jsx)(ConfirmDialog/* default */.Z, {
                open: openConfirmBlockUser,
                actionCloseFnc: function() {
                    return setOpenConfirmBlockUser(false);
                },
                actionSelectedFnc: handleBlockUser,
                title: "本当にブロックしますか？",
                yesText: "ブロックする"
            }),
            openConfirmReportUser && /*#__PURE__*/ (0,jsx_runtime.jsx)(ConfirmDialog/* default */.Z, {
                open: openConfirmReportUser,
                actionCloseFnc: function() {
                    return setOpenConfirmReportUser(false);
                },
                title: "ユーザーをレポートする",
                withTextBox: true,
                textBox: /*#__PURE__*/ (0,jsx_runtime.jsx)(ReportBox/* default */.Z, {
                    targetUserId: user.id,
                    onDialogSubmit: function() {
                        return setOpenConfirmReportUser(false);
                    }
                })
            }),
            currentUser && user && showSubscribingStatusModal && /*#__PURE__*/ (0,jsx_runtime.jsx)(SubscribingStatusModal, {
                creator: user,
                open: showSubscribingStatusModal,
                setOpen: setShowSubscribingStatusModal
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/@amplitude/analytics-browser/lib/esm/index.js + 164 modules
var esm = __webpack_require__(38367);
;// CONCATENATED MODULE: ./components/Profile/FollowButtonsGroup/index.tsx

















var FollowSubscriptionButtons = function(param) {
    var user = param.user;
    var ref, ref1;
    var showPaymentDialog = (0,global/* default */.Z)(function(state) {
        return state.showPaymentDialog;
    });
    var showLogin = (0,global/* default */.Z)(function(state) {
        return state.showLogin;
    });
    var currentUser = (0,timeline/* default */.ZP)(function(state) {
        return state.currentUser;
    });
    var isCurrentUser = (user === null || user === void 0 ? void 0 : user.username) === (currentUser === null || currentUser === void 0 ? void 0 : currentUser.username);
    var isAbleToSub = (user === null || user === void 0 ? void 0 : user.is_creator) && (user === null || user === void 0 ? void 0 : user.is_open_for_subscription);
    var ref2 = (0,react.useState)(user === null || user === void 0 ? void 0 : user.is_followed), isFollowed = ref2[0], setIsFollowed = ref2[1];
    var canUpGradePlan = (0,utils_user/* isAbleToUpgradePlan */.Dn)(user);
    // having prime sub benefits
    var isNotSubbingPrime = !(user === null || user === void 0 ? void 0 : (ref = user.creator_subscription) === null || ref === void 0 ? void 0 : ref.current_plan) || !(user === null || user === void 0 ? void 0 : (ref1 = user.creator_subscription) === null || ref1 === void 0 ? void 0 : ref1.status);
    var renewMode = (0,utils_payment/* isRenewPrimeSubStatus */.WJ)(user);
    var plusPackage = (0,payment/* getPlusPackage */.ME)(user);
    var ableToSubPrimePlus = !!plusPackage && !(0,utils_payment/* isPayingPlus */.W$)(user) && !(0,utils_payment/* isSubbingPrimeByCoin */.r$)(user);
    var showingSubButton = isAbleToSub && (isNotSubbingPrime || renewMode || canUpGradePlan || ableToSubPrimePlus);
    var ref3 = (0,react.useState)(!!(user === null || user === void 0 ? void 0 : user.get_notifications_type)), followingNewPost = ref3[0], setFollowingNewPost = ref3[1];
    var trackAmpEvent = function(eventName) {
        (0,esm/* track */.j)(eventName, {
            creator_user_id: user === null || user === void 0 ? void 0 : user.id,
            creator_badge: user === null || user === void 0 ? void 0 : user.badge,
            creator_follower_number: user === null || user === void 0 ? void 0 : user.follow_count
        });
    };
    var refetchPosts = (0,timeline/* default */.ZP)(function(state) {
        return state.refetchPosts;
    });
    var refetchCurrentProfile = (0,timeline/* default */.ZP)(function(state) {
        return state.refetchCurrentProfile;
    });
    (0,react.useEffect)(function() {
        setIsFollowed(user === null || user === void 0 ? void 0 : user.is_followed);
    }, [
        user === null || user === void 0 ? void 0 : user.is_followed
    ]);
    (0,react.useEffect)(function() {
        setFollowingNewPost(!!(user === null || user === void 0 ? void 0 : user.get_notifications_type));
    }, [
        user === null || user === void 0 ? void 0 : user.get_notifications_type
    ]);
    if (!user) return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    var handleFollowClick = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(userId, isFollowed) {
            var action;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (!currentUser) {
                            _ctx.next = 10;
                            break;
                        }
                        action = isFollowed ? "unfollow" : "follow";
                        trackAmpEvent(action === "follow" ? "Follow Creator" : "Unfollow Creator");
                        if (isFollowed) {
                            setIsFollowed(false);
                        } else {
                            setIsFollowed(true);
                        }
                        _ctx.next = 6;
                        return axios/* default.post */.Z.post("/users/follows", {
                            user_id: userId,
                            action: action
                        });
                    case 6:
                        refetchPosts();
                        refetchCurrentProfile();
                        _ctx.next = 11;
                        break;
                    case 10:
                        {
                            showLogin({});
                        }
                    case 11:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleFollowClick(userId, isFollowed) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleRegistryNotification = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var newType;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        newType = followingNewPost ? "" : "post";
                        if (newType === "post") {
                            setFollowingNewPost(true);
                            trackAmpEvent("Turn On Creator Notification");
                        } else {
                            setFollowingNewPost(false);
                            trackAmpEvent("Turn Off Creator Notification");
                        }
                        _ctx.next = 4;
                        return axios/* default.post */.Z.post("/profiles/followership_notification", {
                            followee_name: user.username,
                            notification_type: newType
                        });
                    case 4:
                        refetchCurrentProfile();
                    case 5:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleRegistryNotification() {
            return _ref.apply(this, arguments);
        };
    }();
    var handlePaymentClick = function(withInitPackage) {
        trackAmpEvent("Click Prime Registration");
        if (currentUser) {
            showPaymentDialog((0,_object_spread/* default */.Z)({
                creator: user
            }, withInitPackage ? {
                initPackageRecurring: payment/* WebPricePackageRecurring.Year */.a5.Year
            } : {}));
        } else {
            showLogin({});
        }
    };
    var subScriptionButton = function() {
        if (!showingSubButton) return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
        var btnText = "";
        var subText = "";
        var withInitPackage = false;
        var btnColor = "";
        if (renewMode || isNotSubbingPrime) {
            btnText = user.is_subscribed_before ? "プライム登録を再開" : "プライム登録を無料体験";
            subText = user.latest_paid_post_published_at ? latestPaidPostTimeStr(user.latest_paid_post_published_at) : " ";
        } else if (ableToSubPrimePlus) {
            var isSubbedPlusBefore = (0,utils_payment/* isSubbedPrimePlusBefore */.If)(user);
            btnText = isSubbedPlusBefore ? "プライムPlusを再開" : "プライムPlusを2週間無料体験";
            subText = user.latest_plus_paid_post_published_at ? latestPaidPlusPostTimeStr(user.latest_plus_paid_post_published_at) : " ";
            btnColor = "lightRed";
        } else if (canUpGradePlan) {
            btnText = "新しい割引プラン";
            subText = " ";
            btnColor = "pink";
            withInitPackage = true;
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            style: {
                width: "calc(64% - 60px)",
                marginRight: "10px"
            },
            className: (FollowButtonsGroup_module_default()).subButton,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BigButton/* default */.Z, {
                text: btnText,
                onClick: function() {
                    return handlePaymentClick(withInitPackage);
                },
                disabled: !isAbleToSub,
                fullWidth: true,
                bigGuyStyle: true,
                subText: subText,
                colorName: btnColor
            })
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (FollowButtonsGroup_module_default()).followSubscriptionButtons,
        children: (!currentUser || !isCurrentUser) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (FollowButtonsGroup_module_default()).followerShipCtrl,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    style: {
                        width: showingSubButton ? "36%" : "calc(100% - 60px)",
                        marginRight: "10px"
                    },
                    className: (FollowButtonsGroup_module_default()).followGroup,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            style: isFollowed ? {
                                width: "80px",
                                paddingRight: "10px"
                            } : {
                                width: "100%"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BigButton/* default */.Z, {
                                text: "フォローする",
                                onText: "",
                                hasOn: true,
                                icon: "follow",
                                fadeColorWhenOn: true,
                                isOn: isFollowed,
                                alternateColor: true,
                                bigGuyStyle: true,
                                onClick: function() {
                                    return handleFollowClick(user.id, isFollowed);
                                },
                                subText: " "
                            })
                        }),
                        isFollowed && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            style: {
                                width: "calc(100% - 75px)"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BigButton/* default */.Z, {
                                text: "通知ON",
                                onText: "通知OFF",
                                hasOn: true,
                                icon: "bell-follow-1",
                                fadeColorWhenOn: true,
                                isOn: followingNewPost,
                                darkOrange: true,
                                fullWidth: true,
                                bigGuyStyle: true,
                                subText: " ",
                                onClick: function() {
                                    return handleRegistryNotification();
                                }
                            })
                        })
                    ]
                }),
                showingSubButton && subScriptionButton(),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    style: {
                        width: "60px",
                        flexShrink: 0
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ThreeDotsMenu, {
                        user: user
                    })
                })
            ]
        })
    });
};
var latestPaidPostTimeStr = function(date) {
    if (!date) return " ";
    var startDate = new Date(date);
    if (startDate.toString() === "Invalid Date") return "";
    var days = Math.floor((new Date().getTime() - startDate.getTime()) / 86400000);
    if (days === 0) return "最新のプライム投稿は".concat((0,utils/* timeSince */.VG)(startDate, api/* Language.Ja */.SQ.Ja));
    return "最新のプライム投稿は".concat(days, "日前");
};
var latestPaidPlusPostTimeStr = function(date) {
    if (!date) return " ";
    var startDate = new Date(date);
    if (startDate.toString() === "Invalid Date") return "";
    var days = Math.floor((new Date().getTime() - startDate.getTime()) / 86400000);
    if (days === 0) return "最新のプライムPlus投稿は".concat((0,utils/* timeSince */.VG)(startDate, api/* Language.Ja */.SQ.Ja));
    return "最新のプライムPlus投稿は".concat(days, "日前");
};
/* harmony default export */ var FollowButtonsGroup = (FollowSubscriptionButtons);

// EXTERNAL MODULE: ./common/utils/membership.ts
var membership = __webpack_require__(77063);
// EXTERNAL MODULE: ./common/utils/pp_tracking.ts
var pp_tracking = __webpack_require__(67027);
// EXTERNAL MODULE: ./components/common/MembershipVipIcon/index.tsx
var MembershipVipIcon = __webpack_require__(756);
;// CONCATENATED MODULE: ./components/Profile/index.tsx


























function Profile(param) {
    var user = param.user, _hideBorder = param.hideBorder, hideBorder = _hideBorder === void 0 ? false : _hideBorder, _hideEditBtn = param.hideEditBtn, hideEditBtn = _hideEditBtn === void 0 ? false : _hideEditBtn, _profilePicEditable = param.profilePicEditable, profilePicEditable = _profilePicEditable === void 0 ? false : _profilePicEditable;
    var ref, ref1;
    var ref2 = (0,react.useState)(false), openImageEditor = ref2[0], setOpenImageEditor = ref2[1];
    var ref3 = (0,react.useState)(), mediaUrl = ref3[0], setMediaUrl = ref3[1];
    var refetchProfile = (0,timeline/* default */.ZP)(function(state) {
        return state.refetchProfile;
    });
    // Help dialog
    var setShowMembershipPayDialog = (0,global/* default */.Z)(function(state) {
        return state.setShowMembershipPayDialog;
    });
    var showLogin = (0,global/* default */.Z)(function(state) {
        return state.showLogin;
    });
    var currentUser = (0,timeline/* default */.ZP)(function(state) {
        return state.currentUser;
    });
    var isCurrentUser = (user === null || user === void 0 ? void 0 : user.username) === (currentUser === null || currentUser === void 0 ? void 0 : currentUser.username);
    var isMobileScreen = (0,utils/* useMediaQuery */.ac)("(max-width: 767px)");
    var browserWidth = (0,utils/* useWindowSize */.iP)().browserWidth;
    var handleFileSelect = (0,react.useCallback)(function(file) {
        setMediaUrl(URL.createObjectURL(file));
        setOpenImageEditor(true);
    }, []);
    // Media upload
    var setSnackbarMessage = (0,global/* default */.Z)(function(state) {
        return state.setSnackbarMessage;
    });
    var ref4 = (0,es.useMutation)(function(url) {
        return axios/* default.post */.Z.post("/profiles/avatars", {
            avatar: url
        });
    }, {
        onSuccess: function() {
            refetchProfile();
        },
        onError: function() {
            setSnackbarMessage({
                type: "error",
                text: "画像の更新が失敗されました"
            });
        }
    }), updateProfilePic = ref4.mutate;
    var ref5 = (0,es.useMutation)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(file) {
            var formData;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        formData = new FormData();
                        formData.append("file", file);
                        _ctx.next = 4;
                        return axios/* default.post */.Z.post("/posts/media", formData, {
                            headers: {
                                "Content-Type": "multipart/form-data"
                            }
                        });
                    case 4:
                        return _ctx.abrupt("return", _ctx.sent.data);
                    case 5:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(file) {
            return _ref.apply(this, arguments);
        };
    }(), {
        onSuccess: function(data) {
            var ref;
            updateProfilePic(data === null || data === void 0 ? void 0 : (ref = data.data) === null || ref === void 0 ? void 0 : ref.data.url);
        },
        onError: function() {
            setSnackbarMessage({
                type: "error",
                text: "画像の更新が失敗されました"
            });
        }
    }), uploadProfilePic = ref5.mutate;
    var ref6 = (0,react.useState)(), anchorEl = ref6[0], setAnchorEl = ref6[1];
    var emotionEl = /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (Profile_module_default()).emotion,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
            src: "/images/icons/emotion-".concat((user === null || user === void 0 ? void 0 : user.emotion) || "add", ".svg"),
            width: 52,
            height: 52,
            alt: "emotion"
        })
    });
    return user ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classnames_default()((Profile_module_default()).profileWrapper, (0,_define_property/* default */.Z)({}, (Profile_module_default()).profileWrapperBorderNone, hideBorder)),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: classnames_default()((Profile_module_default()).firstLine, (0,_define_property/* default */.Z)({}, (Profile_module_default()).infoPage, profilePicEditable)),
                children: [
                    profilePicEditable ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (Profile_module_default()).uploadImage,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FileSelect/* default */.Z, {
                                onFileSelect: handleFileSelect,
                                id: "profile-picture-select",
                                accept: ".jpeg,.jpg,.png",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (Profile_module_default()).profilePicGroup,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(RoundIcon/* default */.Z, {
                                            user: user,
                                            width: isMobileScreen ? browserWidth / 5 : 86,
                                            height: isMobileScreen ? browserWidth / 5 : 86,
                                            hasRing: true,
                                            showLiveFlag: true
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(PopperWrapper/* default */.Z, {
                                            id: "emotion-selector-dashboard",
                                            buttonEl: emotionEl,
                                            contentEl: /*#__PURE__*/ (0,jsx_runtime.jsx)(EmotionSelector/* default */.Z, {}),
                                            anchorEl: anchorEl,
                                            setAnchorEl: setAnchorEl,
                                            hover: true
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (Profile_module_default()).profilePicOverlay,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (Profile_module_default()).camera,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.ZP, {
                                                    name: "camera",
                                                    width: 32,
                                                    height: 32
                                                })
                                            })
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                htmlFor: "profile-picture-select",
                                className: (Profile_module_default()).editProfilePicLabel,
                                children: "プロフィール画像を編集"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageEditor/* default */.Z, {
                                open: openImageEditor,
                                setOpen: setOpenImageEditor,
                                mediaUrl: mediaUrl,
                                onEditComplete: uploadProfilePic,
                                fixedRatio: 1
                            })
                        ]
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(RoundIcon/* default */.Z, {
                        user: user,
                        width: isMobileScreen ? browserWidth / 5 : 86,
                        height: isMobileScreen ? browserWidth / 5 : 86,
                        emotion: user.emotion,
                        showLiveFlag: true,
                        hasRing: true
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Profile_RatingInfoSection, {
                        user: user,
                        isMobileScreen: isMobileScreen,
                        browserWidth: browserWidth
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (Profile_module_default()).userNameGroup,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                        className: (Profile_module_default()).userName,
                        children: user.name
                    }),
                    ((0,membership/* isMembershipAccount */.Qx)(user) || (0,membership/* isIzanaviMember */.Wj)(user)) && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: (Profile_module_default()).userNameIcon,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MembershipVipIcon/* default */.Z, {
                            packageName: (ref = user.membership) === null || ref === void 0 ? void 0 : (ref1 = ref.membership_package) === null || ref1 === void 0 ? void 0 : ref1.package_name,
                            width: 66,
                            height: 35,
                            isIzanavi: (0,membership/* isIzanaviMember */.Wj)(user),
                            onClick: function() {
                                if (!currentUser) {
                                    showLogin({});
                                    return;
                                }
                                setShowMembershipPayDialog({
                                    open: true,
                                    showMembershipStatus: false,
                                    screen: pp_tracking/* ScreenName.Profile */.CG.Profile
                                });
                            }
                        })
                    }),
                    user.is_advertiser && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: (Profile_module_default()).userNameIcon,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.ZP, {
                            name: "done",
                            width: 20,
                            height: 20
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                        className: (Profile_module_default()).country,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                src: "/images/icons/location.svg",
                                width: 32,
                                height: 32
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: user.country.name
                            }),
                            currentUser && isCurrentUser && !hideEditBtn && /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: "/account?tab=info",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    style: {
                                        marginTop: "4px"
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        src: "/images/icons/edit.svg",
                                        width: 24,
                                        height: 24
                                    })
                                })
                            })
                        ]
                    })
                ]
            }),
            user.job && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (Profile_module_default()).userJob,
                children: user.job
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (Profile_module_default()).extraContainer,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Profile_BioSection, {
                        user: user
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FollowButtonsGroup, {
                        user: user
                    })
                ]
            })
        ]
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {});
};


/***/ }),

/***/ 10086:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ EmotionSelector; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(14924);
/* harmony import */ var _home_circleci_project_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _home_circleci_project_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_home_circleci_project_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(93967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(87066);
/* harmony import */ var common_interfaces_api__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(21694);
/* harmony import */ var store_timeline__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(12800);
/* harmony import */ var components_common_Icon__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(37975);
/* harmony import */ var _EmotionSelector_module_scss__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(53811);
/* harmony import */ var _EmotionSelector_module_scss__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_EmotionSelector_module_scss__WEBPACK_IMPORTED_MODULE_8__);










function EmotionSelector() {
    var currentUser = (0,store_timeline__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(function(state) {
        return state.currentUser;
    });
    var refetchProfile = (0,store_timeline__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(function(state) {
        return state.refetchProfile;
    });
    var handleUpdateEmotion = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_home_circleci_project_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(emotion) {
            return _home_circleci_project_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return axios__WEBPACK_IMPORTED_MODULE_7__/* ["default"].post */ .Z.post("/profiles/emotions", {
                            emotion: emotion
                        });
                    case 2:
                        refetchProfile();
                    case 3:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleUpdateEmotion(emotion) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleDeleteEmotion = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_home_circleci_project_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            return _home_circleci_project_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return axios__WEBPACK_IMPORTED_MODULE_7__/* ["default"]["delete"] */ .Z["delete"]("/profiles/emotions");
                    case 2:
                        refetchProfile();
                    case 3:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleDeleteEmotion() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
        className: (_EmotionSelector_module_scss__WEBPACK_IMPORTED_MODULE_8___default().selectEmotionMenu),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                className: (_EmotionSelector_module_scss__WEBPACK_IMPORTED_MODULE_8___default().emotions),
                children: Object.values(common_interfaces_api__WEBPACK_IMPORTED_MODULE_3__/* .Emotion */ .T1).map(function(emotion) {
                    var isActive = emotion === (currentUser === null || currentUser === void 0 ? void 0 : currentUser.emotion);
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()((_EmotionSelector_module_scss__WEBPACK_IMPORTED_MODULE_8___default().emotion), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, (_EmotionSelector_module_scss__WEBPACK_IMPORTED_MODULE_8___default().active), isActive)),
                        onClick: function() {
                            return handleUpdateEmotion(emotion);
                        },
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_common_Icon__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP, {
                                name: "emotion-sel-".concat(emotion),
                                width: 24,
                                height: 24
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                className: (_EmotionSelector_module_scss__WEBPACK_IMPORTED_MODULE_8___default().highlight)
                            })
                        ]
                    }, emotion);
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                className: (_EmotionSelector_module_scss__WEBPACK_IMPORTED_MODULE_8___default().delEmotionBtn),
                onClick: function() {
                    return handleDeleteEmotion();
                },
                children: "ムード絵文字を消す"
            })
        ]
    });
};


/***/ }),

/***/ 74688:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ PopperWrapper; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _material_ui_core_ClickAwayListener__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(52795);
/* harmony import */ var _material_ui_core_Popper__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(84872);
/* harmony import */ var _PopperWrapper_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(10842);
/* harmony import */ var _PopperWrapper_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_PopperWrapper_module_scss__WEBPACK_IMPORTED_MODULE_3__);





function PopperWrapper(param) {
    var buttonEl = param.buttonEl, contentEl = param.contentEl, anchorEl = param.anchorEl, setAnchorEl = param.setAnchorEl, _click = param.click, click = _click === void 0 ? true : _click, _hover = param.hover, hover = _hover === void 0 ? false : _hover, _showArrow = param.showArrow, showArrow = _showArrow === void 0 ? true : _showArrow, _disablePortal = param.disablePortal, disablePortal = _disablePortal === void 0 ? false : _disablePortal, _verticalOffset = param.verticalOffset, verticalOffset = _verticalOffset === void 0 ? 10 : _verticalOffset, _horizontalOffset = param.horizontalOffset, horizontalOffset = _horizontalOffset === void 0 ? 20 : _horizontalOffset, id = param.id;
    var handleClick = function(event) {
        event.preventDefault();
        event.stopPropagation();
        if (!anchorEl) {
            setAnchorEl(event.currentTarget);
        } else {
            setAnchorEl(null);
        }
    };
    var handleMouseEnter = function(event) {
        if (!anchorEl) {
            setAnchorEl(event.currentTarget);
        }
    };
    var handleMouseLeave = function() {
        if (anchorEl) {
            setAnchorEl(null);
        }
    };
    var handleClickAway = function() {
        setAnchorEl(null);
    };
    var open = Boolean(anchorEl);
    var renderBtn = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.cloneElement)(buttonEl, {
        onClick: click ? handleClick : undefined,
        onMouseEnter: hover ? handleMouseEnter : undefined,
        "data-is-open": open
    });
    var arrowOffset = 15;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_ClickAwayListener__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        onClickAway: handleClickAway,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: (_PopperWrapper_module_scss__WEBPACK_IMPORTED_MODULE_3___default().popperWrapper),
            children: [
                renderBtn,
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Popper__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                    id: id,
                    open: open,
                    anchorEl: anchorEl,
                    modifiers: {
                        offset: {
                            enabled: true,
                            offset: "-".concat(horizontalOffset, ", ").concat(verticalOffset)
                        }
                    },
                    disablePortal: disablePortal,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: (_PopperWrapper_module_scss__WEBPACK_IMPORTED_MODULE_3___default().container),
                        onMouseLeave: hover ? handleMouseLeave : undefined,
                        children: [
                            contentEl,
                            showArrow && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: (_PopperWrapper_module_scss__WEBPACK_IMPORTED_MODULE_3___default().arrow),
                                style: {
                                    left: "calc(50% + ".concat(arrowOffset, "px)")
                                }
                            })
                        ]
                    })
                })
            ]
        })
    });
};


/***/ }),

/***/ 39186:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ProgressIcon; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var components_common_Icon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(37975);
/* harmony import */ var _ProgressIcon_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(21029);
/* harmony import */ var _ProgressIcon_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_ProgressIcon_module_scss__WEBPACK_IMPORTED_MODULE_3__);




function ProgressIcon(param) {
    var icon = param.icon, current = param.current, total = param.total, _strokeColor = param.strokeColor, strokeColor = _strokeColor === void 0 ? "#0abc71" : _strokeColor, _secondColor = param.secondColor, secondColor = _secondColor === void 0 ? "#818CEE" : _secondColor, _zoom = param.zoom, zoom = _zoom === void 0 ? 1 : _zoom, _reverse = param.reverse, reverse = _reverse === void 0 ? false : _reverse, _stroke = param.stroke, stroke = _stroke === void 0 ? 3 : _stroke;
    //
    var radius = 24;
    var normalizedRadius = (radius - stroke * 2) * zoom;
    var circumference = normalizedRadius * 2 * Math.PI;
    var progress = current > total ? 1 : reverse ? (total - current) / total : current / total;
    var strokeDashoffset = circumference - progress * circumference;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: (_ProgressIcon_module_scss__WEBPACK_IMPORTED_MODULE_3___default().progressIcon),
        style: {
            width: radius * 2,
            height: radius * 2
        },
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_ProgressIcon_module_scss__WEBPACK_IMPORTED_MODULE_3___default().icon),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_common_Icon__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP, {
                    name: icon,
                    width: 21 * zoom,
                    height: 21 * zoom
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
                height: radius * 2,
                width: radius * 2,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                        stroke: secondColor,
                        fill: "transparent",
                        strokeWidth: 1,
                        r: normalizedRadius,
                        cx: radius,
                        cy: radius
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                        stroke: strokeColor,
                        fill: "transparent",
                        strokeWidth: stroke,
                        strokeDasharray: "".concat(circumference, " ").concat(circumference),
                        style: {
                            strokeDashoffset: strokeDashoffset
                        },
                        r: normalizedRadius,
                        cx: radius,
                        cy: radius
                    })
                ]
            })
        ]
    });
};


/***/ }),

/***/ 70557:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"bioSection":"BioSection_bioSection__EdZFw","bio":"BioSection_bio__AzsDc","notShortMode":"BioSection_notShortMode__gpVXc","readmore":"BioSection_readmore__sLhsB"};

/***/ }),

/***/ 82597:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"followSubscriptionButtons":"FollowButtonsGroup_followSubscriptionButtons__H__TC","followerShipCtrl":"FollowButtonsGroup_followerShipCtrl__D1dlS","followGroup":"FollowButtonsGroup_followGroup__17zc3","subButton":"FollowButtonsGroup_subButton__lGPnW"};

/***/ }),

/***/ 45841:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"profileWrapper":"Profile_profileWrapper__CwFiJ","profileWrapperBorderNone":"Profile_profileWrapperBorderNone__vxKn6","firstLine":"Profile_firstLine__7sYWZ","meterDisableLabel":"Profile_meterDisableLabel__FZHWH","uploadImage":"Profile_uploadImage__UFSee","profilePicGroup":"Profile_profilePicGroup__9gFgy","profilePic":"Profile_profilePic__t8YOk","emotion":"Profile_emotion__bH1Kk","profilePicOverlay":"Profile_profilePicOverlay__VZf5t","camera":"Profile_camera__TtIJP","editProfilePicLabel":"Profile_editProfilePicLabel__HEYrN","badgeGroup":"Profile_badgeGroup__JJyhq","badge":"Profile_badge__xlArX","help":"Profile_help__SpYM7","tooltip":"Profile_tooltip__ghgaS","statsGroup":"Profile_statsGroup__QJfyr","lessMargin":"Profile_lessMargin__SDW3R","stats":"Profile_stats__AmQMV","statsLeft":"Profile_statsLeft__DQzPg","statsGroupCtrl":"Profile_statsGroupCtrl__V5oMF","statsTop":"Profile_statsTop__emiaY","statsRight":"Profile_statsRight__GbgTT","statsText":"Profile_statsText__TOl8S","statsNum":"Profile_statsNum__c92NK","statsBottom":"Profile_statsBottom__7fNHR","infoPage":"Profile_infoPage__EzxRs","userNameGroup":"Profile_userNameGroup__VffSZ","userName":"Profile_userName__bAqiK","userNameIcon":"Profile_userNameIcon__715vL","country":"Profile_country__B2GBN","userJob":"Profile_userJob__tYO1h","extraContainer":"Profile_extraContainer__0S9KR","dialogWrapper":"Profile_dialogWrapper__tS1BZ","closeBtn":"Profile_closeBtn__J4q0E","container":"Profile_container__9w_yk","descriptionSection":"Profile_descriptionSection__2OLvs","header":"Profile_header___MnPA","subheader":"Profile_subheader__yJjKm","smallText":"Profile_smallText__ip_4_","nextBtn":"Profile_nextBtn__3IE9f","completeBtn":"Profile_completeBtn__hEkH_","visualSection":"Profile_visualSection__ynWIr","badges":"Profile_badges__XX41Z","feature":"Profile_feature__wTd4s","featureIcon":"Profile_featureIcon__0JhMq","descGroup":"Profile_descGroup__2TG_g","descTitle":"Profile_descTitle__gxVeP","descText":"Profile_descText__9l0Z7","dots":"Profile_dots__L_sGB"};

/***/ }),

/***/ 63448:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"dialogWrapper":"SubscribingStatusModal_dialogWrapper__ycEjo","closeBtn":"SubscribingStatusModal_closeBtn__5NZvz","descriptionSection":"SubscribingStatusModal_descriptionSection__rmk5p","avatar":"SubscribingStatusModal_avatar__BavZX","header":"SubscribingStatusModal_header__tRJZa","subHeader":"SubscribingStatusModal_subHeader__xxiU_","highlight":"SubscribingStatusModal_highlight__4vnvF","highlight1":"SubscribingStatusModal_highlight1__vJzpD","discountButton":"SubscribingStatusModal_discountButton__sHSp0","reasonChoose":"SubscribingStatusModal_reasonChoose__jbuU_","actionsGroup":"SubscribingStatusModal_actionsGroup__Ts2Tj","subheader":"SubscribingStatusModal_subheader__Gk75o","smallPrint":"SubscribingStatusModal_smallPrint__qWcZ3","link":"SubscribingStatusModal_link__gZ6UH"};

/***/ }),

/***/ 52692:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"threeDotsMenuWrapper":"ThreeDotsMenu_threeDotsMenuWrapper__PVKuG","triggerWrapper":"ThreeDotsMenu_triggerWrapper__I7iSC","contentWrapper":"ThreeDotsMenu_contentWrapper__g_go3","menuWrapper":"ThreeDotsMenu_menuWrapper__S7bIK","dialogWrapper":"ThreeDotsMenu_dialogWrapper__GUox2","header":"ThreeDotsMenu_header__NRkMR","buttons":"ThreeDotsMenu_buttons__jsYRr","button":"ThreeDotsMenu_button__q9HYH","arrow":"ThreeDotsMenu_arrow__T_oR3"};

/***/ }),

/***/ 53811:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"selectEmotionMenu":"EmotionSelector_selectEmotionMenu__RE_AQ","emotions":"EmotionSelector_emotions__ndOUk","emotion":"EmotionSelector_emotion__9EnZC","active":"EmotionSelector_active__xMaek","highlight":"EmotionSelector_highlight__zSKCW","delEmotionBtn":"EmotionSelector_delEmotionBtn__YEzqX"};

/***/ }),

/***/ 10842:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"PopperWrapper_container__g49E_","arrow":"PopperWrapper_arrow__pe_hB"};

/***/ }),

/***/ 21029:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"progressIcon":"ProgressIcon_progressIcon__AWZdu","icon":"ProgressIcon_icon__sW186"};

/***/ })

}]);